import "features/reports/testReport/components/SchoolTestReport.css";
import {capitalize} from "utils/functions";
import {ReportLeftBottom, ReportLeftBottomXs, ReportSegmentsImage} from "features/reports/testReport/utils/reportsFunctions";
import CoverPage from "../shared/CoverPage";
import moment from "moment";
import Chart from "../shared/Chart";
import AboutSection from "./AboutSection";
import ChartSubsection from "../shared/ChartSubsection";
import ChartNoteWrapperBig from "../shared/ChartNoteWrapperBig";
import TableRow from "../shared/TableRow";
import MarkGroup from "../shared/MarkGroup";
import Units from "../shared/Units";
import SubcategorySection from "../shared/SubcategorySection";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useEffect, useState} from "react";
import ScrollBar from "../../../../../shared/ui/ScrollBar";

const Report = ({reportSummary, gradeLevels, graphData, skillsData}: any) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.up("sm"));
    const [left, setLeft] = useState(0);
    const [bottom, setBottom] = useState(0);

    useEffect(() => {
        if (isSmallScreen) {
            setLeft(ReportLeftBottom(reportSummary.score, "school")[0]);
            setBottom(ReportLeftBottom(reportSummary.score, "school")[1]);
        } else {
            setLeft(ReportLeftBottomXs(reportSummary.score, "school")[0]);
            setBottom(ReportLeftBottomXs(reportSummary.score, "school")[1]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="cover-bg">
                <div id="print_page" className="wrapper-cover">
                    <CoverPage coverImage={reportSummary.coverImage} type="school">
                        <>
                            <div className="title">
                                <h1>Raport de evaluare</h1>
                                <h2>Sesiune #{reportSummary.testId}</h2>
                                <h1>Scor {reportSummary.score}</h1>
                            </div>
                            <h2> {reportSummary.studentName && `Elev: ${reportSummary.studentName}`}</h2>
                            <h2>
                                {reportSummary.testTitle !== null
                                    ? capitalize(reportSummary.testTitle)
                                    : reportSummary.testModeId < 3
                                        ? capitalize(reportSummary.type)
                                        : ""}
                                {" "}
                                {reportSummary.testModeId < 3 &&
                                    (reportSummary.testGradeName === "I" || reportSummary.testGradeName === "0" ?
                                        `clasa ${reportSummary.testGradeName}` : `clasa a ${reportSummary.testGradeName}-a`)}
                                {reportSummary.testModeId >= 3 && reportSummary.testGradeName} |{" "}
                                {moment(reportSummary.testStartedAt).locale("ro").format("DD MMMM YYYY")}
                            </h2>
                        </>
                    </CoverPage>

                    <div className="pagebreak"></div>

                    <AboutSection type={reportSummary.type} subject={reportSummary.subject}/>

                    <div className="pagebreak"></div>

                    <div className="section-despre">
                        <h1>Despre Scorul BRIO</h1>
                        <Chart
                            testMode={reportSummary.testModeId}
                            left={left}
                            bottom={bottom}
                            testScore={reportSummary.score}
                            segmentsImage={reportSummary.graphSegmentsImage}
                            big={true}
                            type="school"
                        />
                        {!reportSummary.subjectsExcluded.includes(reportSummary.type) &&
                            gradeLevels.map((gradeLevel: any, index: any) => (
                                <div key={index}>
                                    <ChartSubsection gradeLevel={gradeLevel} score={reportSummary.score} index={index} type="school"/>
                                </div>
                            ))
                        }
                    </div>

                    <div className="pagebreak"></div>
                    {graphData.length > 0 && (
                        <div className="section-despre">
                            <h1>Profilul competențelor evaluate</h1>
                            <ScrollBar forceVisible="x" autoHide={false}>
                                <table className="tabel-note">
                                    <thead>
                                    <tr>
                                        <th className="col-capitol">&nbsp;</th>
                                        <th className="col-values">
                                            <Units type="school"/>
                                            <MarkGroup type="school"/>
                                        </th>
                                    </tr>
                                    </thead>

                                    {graphData.map((section: any, index: any) => (
                                        <tbody key={index}>
                                        <TableRow section={section} index={index}/>
                                        </tbody>
                                    ))}
                                    <tfoot>
                                    <tr className="legenda">
                                        <td>&nbsp;</td>
                                        <td className="col-legend">
                                            <img src="/images/reports/chart-tabel.png" className="chart-tabel" alt=""/>
                                            <Units type="school"/>
                                            <ChartNoteWrapperBig big={false} type="school"/>
                                        </td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </ScrollBar>
                        </div>
                    )}

                    <div className="pagebreak"></div>
                    {skillsData.length > 0 && (skillsData.map((skillData: any, index: any) => (
                        <div key={index}>
                            <SubcategorySection skillsData={skillsData[index]} key={index} type="school"/>
                        </div>
                    )))}
                </div>
            </div>
        </>
    );
};

export default Report;
